import api from '@/apis'

export default {
  state: {
    switch_loading: null,
    on_off: {}
  },
  mutations: {
    SET_AI_CONFIGURATION_SWITCH_LOADING(state, payload) {
      state.switch_loading = payload
    },
    SET_AI_CONFIGURATION_ON_OFF(state, payload) {
      state.on_off = payload
    }
  },
  actions: {
    async fetchAiConfiguration({ commit }) {
      try {
        const response = await api.getDeviceAiConfigSettings()
        if (response.data.success) {
          commit('SET_AI_CONFIGURATION_ON_OFF', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async updateAiConfigRelatedIntent({ commit, dispatch }, payload) {
      try {
        commit('SET_AI_CONFIGURATION_SWITCH_LOADING', 'related_intent')
        const response = await api.updateAiConfigRelatedIntent({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
        dispatch('fetchAiConfiguration')
      } finally {
        commit('SET_AI_CONFIGURATION_SWITCH_LOADING', null)
      }
    },
    async updateAiConfigChatbot({ commit, dispatch }, payload) {
      try {
        commit('SET_AI_CONFIGURATION_SWITCH_LOADING', 'chatbot')
        const response = await api.updateAiConfigChatbot({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
        dispatch('fetchAiConfiguration')
      } finally {
        commit('SET_AI_CONFIGURATION_SWITCH_LOADING', null)
      }
    },
    async updateAiConfigMrc({ commit, dispatch }, payload) {
      try {
        commit('SET_AI_CONFIGURATION_SWITCH_LOADING', 'mrc')
        const response = await api.updateAiConfigMrc({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
        dispatch('fetchAiConfiguration')
      } finally {
        commit('SET_AI_CONFIGURATION_SWITCH_LOADING', null)
      }
    }
  }
}
